/* Farb-gefilterte Produktgalerie: blendet Slides/Thumbnails/Modal-Medien aus,
   deren data-cs-farbe nicht zur gewaehlten Farb-Option passt. Medien ohne
   Token bleiben immer sichtbar (fail-open). Der Initialzustand kommt
   serverseitig aus product-media-gallery.liquid (Klasse cs-farb-hidden);
   dieser Pass korrigiert danach Slider-Cache/Zaehler und uebernimmt jeden
   Farbwechsel.

   Drei Hooks, weil Dawns updateMedia() Klassen bestehender <li> nie anfasst
   (es fuegt nur neue Medien ein, entfernt fehlende und sortiert):
   1. 'change' auf <variant-selects>: sofort filtern, noch vor dem Fetch -
      die Bilder der anderen Farbe liegen ja bereits im DOM.
   2. PUB_SUB_EVENTS.variantChange (global.js, volle Auswahl inkl. Modell):
      nach renderProductInfo -> updateMedia.
   3. PUB_SUB_EVENTS.csMediaPreview (global.js previewPartialMedia, nur
      Farbe gewaehlt, Modell offen): dieser Pfad feuerte frueher gar kein
      Ereignis - Befund Paul 06.09.2026: nur das Hauptbild wechselte, die
      restliche Galerie blieb in der alten Farbe. */
(function () {
  const MAP = { schwarz: 'schwarz', black: 'schwarz', 'weiß': 'weiss', weiss: 'weiss', white: 'weiss' };

  function currentColor(sectionId) {
    const picker = document.getElementById(`variant-selects-${sectionId}`);
    if (!picker) return null;
    for (const el of picker.querySelectorAll('input[type="radio"]:checked, select')) {
      const norm = MAP[(el.value || '').trim().toLowerCase()];
      if (norm) return norm;
    }
    return null;
  }

  function apply(sectionId) {
    const gallery = document.getElementById(`MediaGallery-${sectionId}`);
    if (!gallery) return;
    const color = currentColor(sectionId);
    const toggle = (el) => {
      const t = el.dataset.csFarbe || '';
      el.classList.toggle('cs-farb-hidden', !!color && !!t && t !== color);
    };
    gallery.querySelectorAll('[data-cs-farbe]').forEach(toggle);
    document.querySelectorAll(`#ProductModal-${sectionId} [data-cs-farbe]`).forEach(toggle);

    /* Genau ein aktives Slide: Dawns updateMedia fuegt Slides mit
       serverseitigem is-active ein, ohne das bisherige zu loeschen - zwei
       sichtbare Slides auf dem Desktop ergeben Offset 0 -> Zaehler NaN. */
    const actives = [...gallery.querySelectorAll('.product__media-list li[data-media-id].is-active')];
    const keep = actives.find((li) => !li.classList.contains('cs-farb-hidden'));
    if (!keep) {
      const first = gallery.querySelector('.product__media-list li[data-media-id]:not(.cs-farb-hidden)');
      if (first) gallery.setActiveMedia?.(first.dataset.mediaId);
    } else if (actives.length > 1) {
      gallery.setActiveMedia?.(keep.dataset.mediaId);
    }

    /* SliderComponent cached sliderItems und zaehlt nur clientWidth>0 -
       nach jeder Filterung neu paginieren (x / y + Buttons); ein zweiter
       Lauf nach dem Scroll von setActiveMedia (setTimeout) fixiert den
       Stand, sobald frisch eingefuegte Slides ihr Layout haben. */
    const repage = () => {
      gallery.querySelector(`#GalleryViewer-${sectionId}`)?.resetPages?.();
      gallery.querySelector(`#GalleryThumbnails-${sectionId}`)?.resetPages?.();
    };
    repage();
    clearTimeout(gallery.csRepageTimer);
    gallery.csRepageTimer = setTimeout(repage, 400);
  }

  function init(root) {
    (root || document).querySelectorAll('media-gallery[id^="MediaGallery-"]').forEach((g) => {
      if (g.dataset.csFarbgalerieInit) return;
      g.dataset.csFarbgalerieInit = '1';
      const sectionId = g.id.replace('MediaGallery-', '');
      apply(sectionId);

      /* Hook 1: sofortige Reaktion auf die Farb-Pille (auch ohne Modell). */
      document.getElementById(`variant-selects-${sectionId}`)?.addEventListener('change', () => apply(sectionId));

      /* Hooks 2+3: nach dem asynchronen Galerie-Nachladen (neues Hauptbild
         der Farbe kommt erst mit dem Fetch ins DOM, Zaehler/Seiten danach). */
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        const onUpdate = (event) => {
          if (event?.data?.sectionId !== sectionId) return;
          apply(sectionId);
        };
        subscribe(PUB_SUB_EVENTS.variantChange, onUpdate);
        if (PUB_SUB_EVENTS.csMediaPreview) subscribe(PUB_SUB_EVENTS.csMediaPreview, onUpdate);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  /* Theme-Editor laedt Sections neu, ohne DOMContentLoaded zu feuern. */
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
